import React, { useMemo } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import { asCurrency } from "../../../../utils";
import { Box } from "@material-ui/core";
import OperatingIncome from "./OperatingIncome/OperatingIncome";
import AdvertisingIncome from "./AdvertisingIncome/AdvertisingIncome";
import { useLocation } from "react-router";

const useStyles = makeStyles({
  tabSubTitle: {
    background: "#aaa",
    textTransform: "capitalize"
  }
});

export const RevenueContent = props => {
  const classes = useStyles();
  const query = new URLSearchParams(useLocation().search);

  const { totalRevenue, items, defaultItems, chapterFinancial, reportID } =
    props;

  const chapterID = useMemo(() => {
    return reportID !== "add"
      ? chapterFinancial.chapter.id
      : query.get("chapter");
  }, [reportID, chapterFinancial]);

  const year = useMemo(() => {
    return reportID !== "add" ? chapterFinancial.year : query.get("year");
  }, [reportID, chapterFinancial]);

  return (
    <Box>
      <Typography>
        <strong>Revenue</strong>
      </Typography>
      <Box mb={1} />
      <OperatingIncome
        data={items}
        defaultData={defaultItems}
        chapterID={chapterID}
        year={year}
        {...props}
      />
      <AdvertisingIncome
        data={items}
        defaultData={defaultItems}
        chapterID={chapterID}
        year={year}
        {...props}
      />
      <Box
        display="flex"
        justifyContent="space-between"
        p={1}
        mb={2}
        className={classes.tabSubTitle}
      >
        <Typography>
          <strong>Total Revenue</strong>
        </Typography>
        <Typography>{asCurrency(totalRevenue)}</Typography>
      </Box>
    </Box>
  );
};
